import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

// Use environment variable
const API_URL = process.env.REACT_APP_API_URL ;

// CREATE
export const createTeamMember = createAsyncThunk('team/create', async (formData, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/create-team`, {
      method: 'POST',
      body: formData,
    });
    const data = await res.json();

    if (!res.ok) throw new Error(data.message || 'Create failed');

    toast.success('Team member created');
    return data.teamMember;
  } catch (err) {
    toast.error(err.message || 'Create error');
    return thunkAPI.rejectWithValue(err.message);
  }
});

// FETCH
export const fetchTeamMembers = createAsyncThunk('team/fetchAll', async (_, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/get-all-team`);
    const data = await res.json();

    if (!res.ok) throw new Error(data.message || 'Fetch failed');
    return data.teamMembers || [];
  } catch (err) {
    toast.error(err.message || 'Fetch error');
    return thunkAPI.rejectWithValue(err.message);
  }
});

// UPDATE
export const updateTeamMember = createAsyncThunk('team/update', async ({ id, formData }, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/update-team/${id}`, {
      method: 'PUT',
      body: formData,
    });
    const data = await res.json();

    if (!res.ok) throw new Error(data.message || 'Update failed');
    toast.success('Team member updated');
    return data.teamMember;
  } catch (err) {
    toast.error(err.message || 'Update error');
    return thunkAPI.rejectWithValue(err.message);
  }
});

// DELETE
export const deleteTeamMember = createAsyncThunk('team/delete', async (id, thunkAPI) => {
  try {
    const res = await fetch(`${API_URL}/delete-team/${id}`, { method: 'DELETE' });
    const data = await res.json();

    if (!res.ok) throw new Error(data.message || 'Delete failed');
    toast.success('Team member deleted');
    return id;
  } catch (err) {
    toast.error(err.message || 'Delete error');
    return thunkAPI.rejectWithValue(err.message);
  }
});

const teamSlice = createSlice({
  name: 'team',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createTeamMember.pending, (state) => { state.loading = true; })
      .addCase(createTeamMember.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(createTeamMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTeamMembers.pending, (state) => { state.loading = true; })
      .addCase(fetchTeamMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchTeamMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTeamMember.pending, (state) => { state.loading = true; })
      .addCase(updateTeamMember.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.list.findIndex((m) => m.id === action.payload.id);
        if (index !== -1) state.list[index] = action.payload;
      })
      .addCase(updateTeamMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteTeamMember.pending, (state) => { state.loading = true; })
      .addCase(deleteTeamMember.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter((m) => m.id !== action.payload);
      })
      .addCase(deleteTeamMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default teamSlice.reducer;
